import { Helpers } from "../helpers/helpers";
import { FormHelpers, AjaxOptions } from "../helpers/form-helpers";
import { Modal, ModalEvent } from "../modal";
import { Distributor, SearchRequest } from "../locator";
import Locator = require("../locator");



export class DistributorModal {
	private distributorLoaders: NodeListOf<HTMLElement>;
	private modalBody: HTMLElement;
	private distributorCol: HTMLElement;
	private salesRepLoader: NodeListOf<HTMLElement>;
	private salesRepRow: HTMLElement;
	private contentTemplate: Element;
	constructor() {
		const triggerSelector = ".fixed-icons .sales-rep a";
		const contactModal = document.querySelector('#sales-contact-modal');
		
		if (Helpers.isNullOrUndefined(contactModal)) return;
		contactModal.classList.add('distributor-modal');
		this.contentTemplate = document.querySelector('.modal-section-template');
		this.modalBody = document.querySelector('#sales-contact-modal .modal-body') as HTMLElement;
		this.distributorCol = this.modalBody.querySelector('.distributor .col') as HTMLElement;
		this.distributorLoaders = this.distributorCol.querySelectorAll('.loader') as NodeListOf<HTMLElement>;
		this.salesRepRow = this.modalBody.querySelector('.sales-reps') as HTMLElement;
		this.salesRepLoader = this.salesRepRow.querySelectorAll('.loader') as NodeListOf<HTMLElement>;
		if (!Helpers.elementExists(triggerSelector)) return;

		const modal = new Modal(triggerSelector, '#sales-contact-modal', (e: ModalEvent) => {


			this.showLoader(this.distributorLoaders);
			this.showLoader(this.salesRepLoader);
			if (("geolocation" in navigator)) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const searchRequest: SearchRequest = {
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
							culture: Helpers.getCurrentCulture(),
							maxResults: 1,
							searchRadius: 99999,
							productAndSystems: '',
							query: '',
							stateCode: '',
							countryCode: '',
							countyId: ''
						};
						this.search(searchRequest);
					},
					(error) => {
						console.warn(error);
						let message = "";
						switch (error.code) {
						case error.PERMISSION_DENIED:
						case error.POSITION_UNAVAILABLE:
						case error.TIMEOUT:							
							this.searchByIp();
							break;
						}
						
					}
				);				
			}			
		});
	}
	
	private searchByIp() {
	
		FormHelpers.postAjax({
			url: "/distributor/by-ip",
			data: Helpers.getCurrentCulture(),
			success: (response) => {
				const distributor = response as Distributor;
				this.createDistributor(distributor);
			},
			error: (response) => {
				console.log(response);
				this.hideLoader(this.distributorLoaders);
			}
		});
		const r = {} as SearchRequest;
		this.searchSalesRep(r);
	}

	private search(searchRequest: SearchRequest ) {
		const noDistributorMessage = this.modalBody.querySelector('.no-distributor') as HTMLElement;
		//this.showLoader(this.distributorLoaders);
		noDistributorMessage.classList.add('d-none')
		FormHelpers.postAjax({
			url: "/distributor/closest",
			data: searchRequest,
			success: (response) => {
				const distributor = response as Distributor;
				
				console.log(distributor);

				if (!distributor || !distributor.name) {
					noDistributorMessage.classList.remove('d-none')
					this.hideLoader(this.distributorLoaders);
					return;
				}

				
				this.createDistributor(distributor);
			},
			error: (response) => {
				console.log(response);
				noDistributorMessage.classList.remove('d-none')
				this.hideLoader(this.distributorLoaders);
			}
		});
		
		this.searchSalesRep(searchRequest);
	}
	
	private searchSalesRep(searchRequest: SearchRequest) {
		//this.showLoader(this.salesRepLoader);
		FormHelpers.postAjax({
			url: "/distributor/sales-rep",
			data: searchRequest,
			success: (response) => {
				const salesReps = response as SalesRep[];				
				this.createSalesReps(salesReps);
			},
			error: (response) => {
				console.log(response);
				this.hideLoader(this.distributorLoaders);
			}
		});
	}
	
	private showLoader(loader: NodeListOf<HTMLElement>) {
		loader.forEach(l=>l.classList.remove('d-none'));
	}
	
	private hideLoader(loader: NodeListOf<HTMLElement>) {		
		loader.forEach(l=>l.classList.add('d-none'));
	}
	
	private createDistributor(distributor: Distributor) {
		
		const result = this.contentTemplate.cloneNode(true) as HTMLElement;
		result.classList.remove('modal-section-template');
		result.classList.add('distributor-result');
		const details = result.querySelector('.details') as HTMLElement;
		result.querySelector('.image').remove();
		details.querySelector('h3').innerHTML = distributor.name;
		details.querySelector('.phone a').innerHTML = distributor.phone;
		const websiteItem = details.querySelector('.website') as HTMLElement;
		const websiteLink = websiteItem.querySelector('a');
	
		
		let website = distributor.website;
		if (!website) {
			websiteItem.remove();
		} else {
			if (!website.startsWith('http')) {
				website += 'http://' + website;

			}
			websiteLink.innerHTML = distributor.website;
			websiteLink.setAttribute('href', website);
		}
		details.querySelector('.email').remove();
		const anchor = result.querySelector('.button-secondary') as HTMLAnchorElement;
		anchor.href = distributor.detailPage.replace('~','');
		this.distributorCol.querySelectorAll('.distributor-result').forEach(el=>el.remove());
		this.distributorCol.append(result);
		this.hideLoader(this.distributorLoaders);
	}

	private createSalesReps(salesReps: SalesRep[]) {
		const col1 = this.salesRepRow.querySelector('.col:first-child');
		const col2 = this.salesRepRow.querySelector('.col:last-child');
		const rsm = salesReps.find(s=>s.role === 'RSM');
		const insideSales = salesReps.find(s=>s.role === 'IS');
		const aceSales = salesReps.find(s=>s.role === 'ACE');
		this.salesRepRow.querySelectorAll('.sales-rep-result').forEach(el=>el.remove());
	
		let repColMap = [{rep:rsm, col:col1}, {rep:insideSales, col:col2}];
		if (salesReps.length === 1 || !insideSales) {
			repColMap = [{rep:salesReps[0], col:col1}];
			col2.classList.add('d-none');
		}
		repColMap.forEach(salesRepCol=> {
			const salesRep = salesRepCol.rep;
			if (salesRep) {
				const result = this.contentTemplate.cloneNode(true) as HTMLElement;
				const image = result.querySelector('.image') as HTMLElement;
				const details = result.querySelector('.details') as HTMLElement;
				const phone = details.querySelector('.phone');
				const email = details.querySelector('.email');
				result.classList.remove('modal-section-template');
				result.classList.add('sales-rep-result');			
				
				details.querySelector('h3').innerHTML = salesRep.name;
				
				
		
				phone.querySelector('a').innerHTML = salesRep.phone;
				email.querySelector('a').innerHTML = salesRep.email;
				email.querySelector('a').setAttribute('href', `mailto:${salesRep.email}`);
				details.querySelector('.website').remove();

				if (!salesRep.phone) {
					phone.remove();
				}

				if (!salesRep.email) {
					email.remove();
				}
				
				if (salesRep.photo) {
					let salesRepImage = new Image();
					salesRepImage.src = salesRep.photo;
					salesRepImage.onload = function() {
						let imgElement = document.createElement("img");
						
						image.append(imgElement);
					}
					salesRepImage.onerror = function() {
					
						image.style.display = "none";
					};
					
				} else {
					image.remove();
				}
				
				result.querySelector('.button-secondary').remove();
				salesRepCol.col.append(result);
				
			}
		})

		this.hideLoader(this.salesRepLoader);
	}


}

export interface SalesRep {
	rep_id: string;
	division: string;
	role: string;
	name: string;
	company: string;
	title: string;
	phone: string;
	email: string;
	photo: string;
}